import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { Search } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
@Component({
  selector: 'app-master-calendar-form',
  templateUrl: './master-calendar-form.component.html',
  styleUrls: ['./master-calendar-form.component.css']
})
export class MasterCalendarFormComponent implements OnInit {
  title = "Add Master Calendar";
  data: any = {};
  formInvalid: boolean = false;
  c: any = {};
  r: any = {};
  mode: any;
  calendar_id: any;
  MonthList: any
  EndMonthList: any
  FristWeekOfList: any =[]
  SecondWeekOfList: any
  ThiredWeekOfList: any
  HalfDayList: any
  fourthWeekOf: any =[];
  maxcal : number; 
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {

  }

  ngOnInit() {
    
    this.route.params.subscribe(params => {
      this.calendar_id = params['calendar_id'];
      this.mode = params['mode'];

      if (this.calendar_id > 0) {
        this.GetCalenderById(this.calendar_id)
      }
    });

    if (this.mode == 'View') {
      this.title = "View Master Calendare ";
    }
    else if (this.mode == 'Edit') {
      this.title = "Edit Master Calendar ";
    }
    else{
      this.getmaxcalendaryear()

      this.c.fin_ind = 'No';
    }
    this.getMonths()
    this.getEndMonths()
    this.getFristweekOf()
  }
  getMonths() {
    debugger;
    this.data = this.userService.GetMonth();
    this.data.subscribe(
      (response) => {
        this.MonthList = response.StartMonthModel;        
        if ((this.mode != 'View') || (this.mode != 'Edit')) {
          this.c.code_value = 2012;
          this.c.code_value1 = 2023;
        }
      })
  }

  getmaxcalendaryear(){
    this.data = this.userService.uspGetMaximumCalendar();
    this.data.subscribe(
      (response) => {
        this.maxcal = response;
        this.c.year =  this.maxcal;        
      })
  }

  getEndMonths() {
    debugger;
    this.data = this.userService.GetEndMonth();
    this.data.subscribe(
      (response) => {
        this.EndMonthList = response.EndMonthModel;
      })
  }

  getFristweekOf() {
    debugger;
    this.data = this.userService.GetFristWeekOff();
    this.data.subscribe(
      (response) => {
        this.FristWeekOfList = response.WeekOfOneModel;
        

        if ((this.mode != 'View') || (this.mode != 'Edit')) {
          this.c.code_value2 = 'Sunday';
          this.First('Sunday');
          this.c.code_value3 = 'Saturday';
          this.Second('Saturday');
        }
      })
  }

  // getSecondWeekOf() {
  //   debugger;
  //   this.data = this.userService.GetSecondWeekOff();
  //   this.data.subscribe(
  //     (response) => {
  //       this.SecondWeekOfList = response.WeekOffTwoModel;
  //       console.log('seco');
  //       console.log(this.SecondWeekOfList);
  //     })
  // }




  // GetThiredWeekOf() {
  //   debugger;
  //   this.data = this.userService.GetThiredWeekOff();
  //   this.data.subscribe(
  //     (response) => {
  //       this.ThiredWeekOfList = response.WeekOffThiredModel;
  //     })
  // }

  // GetHalfDay() {
  //   debugger;
  //   this.data = this.userService.GetHafDay();
  //   this.data.subscribe(
  //     (response) => {
  //       this.HalfDayList = response.HalfDayModel;       
  //     })
  // }

  ngAfterViewInit() {
    var first = "--Select--"
    var year = 2019;
    var till = 3050;
    var options = "";
    for (var y = year; y <= till; y++) {
      // options = "<option>"+ first +"</option>";
      options += "<option>" + y + "</option>";
    }

    document.getElementById("year").innerHTML = "Select" + options;
  }
  SaveCaste(Caste: NgForm) {
    debugger;
    Caste.value.year =  this.maxcal
    if (Caste.invalid) {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }
    else {
      //Caste.value.Rlg_Id_FK= this.r.Rlg_Id;                   
      this.data = this.userService.PostCalender(Caste.value);
      this.data.subscribe(
        (response) => {
          Caste.reset();
          Caste.resetForm();
          Caste.form.markAsPristine();
          Caste.form.markAsUntouched();
          swal('Success!', 'Calender  Added Successfully .', 'success');
          this.router.navigate(['/home/masters/master-calendar']);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401) {
            this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
  }

  GetCalenderById(calendar_id) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetCalenderById(calendar_id);
    this.data.subscribe(
      (response: any) => {
        this.c = response;        
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }


  UpdateCasteDetails(Caste: NgForm) {
   debugger;    
    this.data = this.userService.UpdateCalDetails(this.calendar_id, Caste.value);
    this.data.subscribe(
      (response) => {
        swal('Success!', ' Calender details updated Successfully .', 'success');
        document.getElementById('loader-spinner').style.display = "none";
        this.router.navigate(['/home/masters/master-calendar']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.HandlerError(error);
        }

      });
  }

  Cancel() {
    this.c.calendar_code = '';
    this.c.year = '';
    this.c.code_value = '';
    this.c.code_value1 = '';
    this.c.code_value2 = '';
    this.c.code_value3 = '';
    this.c.code_value4 = '';
    this.c.code_value5 = '';
    this.c.fin_ind = '';
  }

  Doo(year){   
    this.data = this.userService.UpdateToHoliday(year);
    this.data.subscribe(
      (response) => {
        swal('Success!', ' Calender details updated to Holiday list Successfully .', 'success');
        document.getElementById('loader-spinner').style.display = "none";
        //this.router.navigate(['/home/masters/master-calendar']);
        this.c.AddToholiday = 1;
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.HandlerError(error);
        }
      });
  }

  GetCalendar(year) {
    alert(year)
    this.data = this.userService.GetAllCalendarList();
    this.data.subscribe(
      (response) => {        
       var list = response.filter(a => a.year == year)
       if(list.length>0){
        swal('Warning!', 'This year already added', 'warning');
        this.c.year = 0;
       }
      })
  }

  First(code){ 
    debugger;      
    this.SecondWeekOfList =  this.FristWeekOfList.filter(a=>a.code_value2 != code)  
  }

  Second(code){   
    this.ThiredWeekOfList =  this.SecondWeekOfList.filter(a=>a.code_value2 != code)
  }

  Third(code){
    this.fourthWeekOf =  this.ThiredWeekOfList.filter(a=>a.code_value2 != code)
  }
}



// WEBPACK FOOTER //
// ./src/app/master/master-calendar/master-calendar-form/master-calendar-form.component.ts